var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"STUDENT SERVICES","title":"Health Management","description":"Maintain clinic visits, medical histories, medication and emergency records.","count-label":"health tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }